import {createStyles, LinearProgress, withStyles} from '@material-ui/core';

export const BorderLinearProgress = withStyles((theme) =>
    createStyles({
        root: {
            width: '100%',
            height: props => props.height || theme.spacing(1),
            borderRadius: 5,
        },
        colorPrimary: {
            backgroundColor: theme.palette.grey[400],
        },
        bar: {
            borderRadius: 5,
            backgroundColor: theme.palette.primary.main,
        },
    }))(LinearProgress);



// WEBPACK FOOTER //
// ./components/progress/border-linear-progress.js